import { useEffect, useRef } from 'react';
import { cancelAnimation, makeMutable } from 'react-native-reanimated';
export const useReactiveSharedValue = value => {
  const ref = useRef(null);

  if (ref.current === null) {
    // @ts-ignore
    ref.current = makeMutable(value);
  } else if (ref.current.value !== value) {
    ref.current.value = value;
  }

  useEffect(() => {
    return () => {
      if (ref.current) {
        cancelAnimation(ref.current);
      }
    };
  }, []);
  return ref.current;
};
//# sourceMappingURL=useReactiveSharedValue.js.map